'use strict';
import * as $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver from "./com.raquo.airstream.common.-Internal-Try-Observer.js";
import * as $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal from "./com.raquo.airstream.common.-Single-Parent-Signal.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024 from "./com.raquo.airstream.core.-Airstream-Error$.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable from "./com.raquo.airstream.core.-Base-Observable.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed from "./com.raquo.airstream.core.-Named.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal from "./com.raquo.airstream.core.-Writable-Signal.js";
import * as $j_com$002eraquo$002eairstream$002edistinct$002e$002dDistinct$002dSignal from "./com.raquo.airstream.distinct.-Distinct-Signal.js";
import * as $j_com$002eraquo$002eairstream$002esplit$002e$002dSplit$002dChild$002dSignal from "./com.raquo.airstream.split.-Split-Child-Signal.js";
import * as $j_com$002eraquo$002eairstream$002esplit$002e$002dSplit$002dSignal$0024$0024anon$00241 from "./com.raquo.airstream.split.-Split-Signal$$anon$1.js";
import * as $j_com$002eraquo$002eairstream$002etiming$002e$002dSync$002dDelay$002dStream from "./com.raquo.airstream.timing.-Sync-Delay-Stream.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dTuple4 from "./scala.-Tuple4.js";
import * as $j_scala$002ecollection$002emutable$002e$002dMap$0024 from "./scala.collection.mutable.-Map$.js";
import * as $j_scala$002escalajs$002ejs$002e$002dArray$002dOps$0024 from "./scala.scalajs.js.-Array-Ops$.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d from "./scala.scalajs.runtime.-Anon-Function0.$$-Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
var $p;
function $p_Lcom_raquo_airstream_split_SplitSignal__memoizedProject__O__O($thiz, nextInputs) {
  var nextKeys = $j_java$002elang$002e$002dObject.$ct_scm_HashSet__(new $j_java$002elang$002e$002dObject.$c_scm_HashSet());
  var duplicateKeys = ($thiz.v1.uZ ? [] : null);
  var f = ((nextInput) => {
    var memoizedKey = $thiz.yJ.j(nextInput);
    if (($thiz.v1.uZ && nextKeys.ae(memoizedKey))) {
      if ((!$j_scala$002escalajs$002ejs$002e$002dArray$002dOps$0024.$m_sjs_js_ArrayOps$().SW(duplicateKeys, memoizedKey))) {
        duplicateKeys.push(memoizedKey);
      }
    }
    nextKeys.eP(memoizedKey);
    var this$6 = $thiz.g2.S(memoizedKey);
    if (this$6.k()) {
      var cachedSignalAndOutput = $j_java$002elang$002e$002dObject.$m_s_None$();
    } else {
      var x0 = this$6.C();
      var cachedSignalAndOutput = new $j_java$002elang$002e$002dObject.$c_s_Some(new $j_java$002elang$002e$002dObject.$c_T2(x0.h0, x0.kf));
    }
    if (cachedSignalAndOutput.k()) {
      var inputSignal = $thiz.EM.j(new $j_com$002eraquo$002eairstream$002esplit$002e$002dSplit$002dChild$002dSignal.$c_Lcom_raquo_airstream_split_SplitChildSignal($thiz.EU, new $j_java$002elang$002e$002dObject.$c_s_Some(new $j_java$002elang$002e$002dObject.$c_T2(nextInput, $thiz.iB.gs())), new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d.$c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
        var maybeMemoizedValue = $thiz.g2.S(memoizedKey);
        if ((maybeMemoizedValue instanceof $j_java$002elang$002e$002dObject.$c_s_Some)) {
          var memoizedValue = maybeMemoizedValue.Q;
          var memoizedParentLastUpdateId = (memoizedValue.iU | 0);
          var $x_2 = (($thiz.iB.gs() > memoizedParentLastUpdateId) ? ($thiz.id(), $thiz.g2.S(memoizedKey)) : maybeMemoizedValue);
        } else {
          var $x_2 = $j_java$002elang$002e$002dObject.$m_s_None$();
        }
        var this$13 = $x_2;
        if (this$13.k()) {
          return $j_java$002elang$002e$002dObject.$m_s_None$();
        } else {
          var x0$1 = this$13.C();
          return new $j_java$002elang$002e$002dObject.$c_s_Some(new $j_java$002elang$002e$002dObject.$c_T2(x0$1.ke, x0$1.iU));
        }
      }))));
      if (($j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z($thiz) && $thiz.rK)) {
        $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(inputSignal, $thiz.rJ, true);
      }
      var $x_1 = new $j_java$002elang$002e$002dObject.$c_T2(inputSignal, $thiz.ET.jj(memoizedKey, nextInput, inputSignal));
    } else {
      var $x_1 = cachedSignalAndOutput.C();
    }
    var nextSignalAndOutput = $x_1;
    var inputSignal$1 = nextSignalAndOutput.ac;
    var nextOutput = nextSignalAndOutput.ad;
    $thiz.g2.QP(memoizedKey, new $j_scala$002e$002dTuple4.$c_T4(nextInput, inputSignal$1, nextOutput, $thiz.iB.gs()));
    return nextOutput;
  });
  if ((nextInputs === $j_java$002elang$002e$002dObject.$m_sci_Nil$())) {
    var $x_3 = $j_java$002elang$002e$002dObject.$m_sci_Nil$();
  } else {
    var x0$2 = nextInputs.E();
    var h = new $j_java$002elang$002e$002dObject.$c_sci_$colon$colon(f(x0$2), $j_java$002elang$002e$002dObject.$m_sci_Nil$());
    var t = h;
    var rest = nextInputs.H();
    while ((rest !== $j_java$002elang$002e$002dObject.$m_sci_Nil$())) {
      var x0$3 = rest.E();
      var nx = new $j_java$002elang$002e$002dObject.$c_sci_$colon$colon(f(x0$3), $j_java$002elang$002e$002dObject.$m_sci_Nil$());
      t.ao = nx;
      t = nx;
      rest = rest.H();
    }
    var $x_3 = h;
  }
  var nextOutputs = $x_3;
  $thiz.g2.Pw().a6(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((memoizedKey$1) => {
    if ((!nextKeys.ae(memoizedKey$1))) {
      if ($thiz.rK) {
        $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V($thiz.g2.j(memoizedKey$1).h0, $thiz.rJ);
      }
      $thiz.g2.WS(memoizedKey$1);
    }
  })));
  if (($thiz.v1.uZ && ((duplicateKeys.length | 0) !== 0))) {
    $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024.$m_Lcom_raquo_airstream_core_AirstreamError$().eb($j_java$002elang$002e$002dObject.$ct_jl_Exception__T__(new $j_java$002elang$002e$002dObject.$c_jl_Exception(), (((("Duplicate keys detected in {" + $thiz.iB) + "}.split(): `") + $j_java$002elang$002e$002dObject.$f_sc_IterableOnceOps__mkString__T__T__T__T($j_java$002elang$002e$002dObject.$ct_sjs_js_WrappedArray__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjs_js_WrappedArray(), duplicateKeys), "", "`, `", "")) + "`. This is a bug in your code. See comment in Airstream's DuplicateKeysConfig.scala.")));
  }
  return nextOutputs;
}
export { $p_Lcom_raquo_airstream_split_SplitSignal__memoizedProject__O__O as $p_Lcom_raquo_airstream_split_SplitSignal__memoizedProject__O__O };
/** @constructor */
function $c_Lcom_raquo_airstream_split_SplitSignal(parent, key, distinctCompose, project, splittable, duplicateKeysConfig, strict) {
  this.EQ = null;
  this.EP = false;
  this.ER = null;
  this.yI = 0;
  this.EN = null;
  this.EO = null;
  this.EW = false;
  this.yK = null;
  this.ES = false;
  this.EL = 0;
  this.iB = null;
  this.yJ = null;
  this.EM = null;
  this.ET = null;
  this.R3 = null;
  this.v1 = null;
  this.rK = false;
  this.EV = 0;
  this.g2 = null;
  this.EU = null;
  this.rJ = null;
  this.iB = parent;
  this.yJ = key;
  this.EM = distinctCompose;
  this.ET = project;
  this.R3 = splittable;
  this.v1 = duplicateKeysConfig;
  this.rK = strict;
  this.EQ = (void 0);
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  this.yI = 0;
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.yK = (void 0);
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__$init$__V(this);
  this.EV = ((1 + parent.dT()) | 0);
  this.g2 = $j_scala$002ecollection$002emutable$002e$002dMap$0024.$m_scm_Map$().br();
  this.EU = new $j_com$002eraquo$002eairstream$002etiming$002e$002dSync$002dDelay$002dStream.$c_Lcom_raquo_airstream_timing_SyncDelayStream(parent, this);
  this.rJ = new $j_com$002eraquo$002eairstream$002esplit$002e$002dSplit$002dSignal$0024$0024anon$00241.$c_Lcom_raquo_airstream_split_SplitSignal$$anon$1();
}
export { $c_Lcom_raquo_airstream_split_SplitSignal as $c_Lcom_raquo_airstream_split_SplitSignal };
$p = $c_Lcom_raquo_airstream_split_SplitSignal.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_split_SplitSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_split_SplitSignal() {
}
export { $h_Lcom_raquo_airstream_split_SplitSignal as $h_Lcom_raquo_airstream_split_SplitSignal };
$h_Lcom_raquo_airstream_split_SplitSignal.prototype = $p;
$p.dP = (function() {
  return this.EQ;
});
$p.dd = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.b = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.gA = (function() {
  return this.EP;
});
$p.fm = (function() {
  return this.ER;
});
$p.ea = (function(x$1) {
  this.EP = x$1;
});
$p.gD = (function(x$1) {
  this.ER = x$1;
});
$p.f = (function(obj) {
  return (this === obj);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$systemIdentityHashCode(this);
});
$p.gs = (function() {
  return this.yI;
});
$p.kI = (function(x$1) {
  this.yI = x$1;
});
$p.hm = (function(observer) {
  observer.fY($j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this));
});
$p.ew = (function() {
  return this.EN;
});
$p.ey = (function() {
  return this.EO;
});
$p.hw = (function() {
  return this.EW;
});
$p.g1 = (function(x$1) {
  this.EW = x$1;
});
$p.hf = (function(x$0) {
  this.EN = x$0;
});
$p.hg = (function(x$0) {
  this.EO = x$0;
});
$p.l3 = (function() {
  return this.yK;
});
$p.rb = (function(x$1) {
  this.yK = x$1;
});
$p.b3 = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$p.fW = (function(nextValue, transaction) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver.$f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.fV = (function(nextError, transaction) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver.$f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$p.rc = (function() {
  return this.ES;
});
$p.tQ = (function() {
  return this.EL;
});
$p.kJ = (function(x$1) {
  this.EL = x$1;
});
$p.u2 = (function(x$0) {
  this.ES = x$0;
});
$p.hp = (function() {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__onWillStart__V(this);
});
$p.ll = (function(nextValue, nextParentLastUpdateId) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V(this, nextValue, nextParentLastUpdateId);
});
$p.dT = (function() {
  return this.EV;
});
$p.id = (function() {
  return this.iB.b3().ra(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextInputs) => $p_Lcom_raquo_airstream_split_SplitSignal__memoizedProject__O__O(this, nextInputs))));
});
$p.fX = (function(nextParentValue, transaction) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextParentValue, transaction);
  nextParentValue.eT(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextError) => {
    $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
  })), new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextEvent) => {
    $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, $p_Lcom_raquo_airstream_split_SplitSignal__memoizedProject__O__O(this, nextEvent), transaction);
  })));
});
$p.hn = (function() {
  if (this.rK) {
    this.iB.b3().a6(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((inputs) => {
      var these = inputs;
      while ((!these.k())) {
        var x0 = these.E();
        var memoizedKey = this.yJ.j(x0);
        var this$3 = this.g2.S(memoizedKey);
        var maybeInputSignal = (this$3.k() ? $j_java$002elang$002e$002dObject.$m_s_None$() : new $j_java$002elang$002e$002dObject.$c_s_Some(this$3.C().h0));
        if ((!maybeInputSignal.k())) {
          $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(maybeInputSignal.C(), this.rJ, true);
        }
        these = these.H();
      }
    })));
  }
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__onStart__V(this);
});
$p.ho = (function() {
  if (this.rK) {
    this.g2.Pw().a6(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((memoizedKey) => {
      $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(this.g2.j(memoizedKey).h0, this.rJ);
    })));
  }
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__onStop__V(this);
});
$p.eB = (function() {
  return this.iB;
});
$p.hi = (function(isSame) {
  return new $j_com$002eraquo$002eairstream$002edistinct$002e$002dDistinct$002dSignal.$c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$p.dS = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_split_SplitSignal = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_split_SplitSignal, "com.raquo.airstream.split.SplitSignal", ({
  ha: 1,
  a1: 1,
  M: 1,
  ai: 1,
  ak: 1,
  au: 1,
  az: 1,
  as: 1,
  aQ: 1,
  aj: 1,
  ay: 1,
  b1: 1
}));
export { $d_Lcom_raquo_airstream_split_SplitSignal as $d_Lcom_raquo_airstream_split_SplitSignal };
